define((require) => {
    "use strict";

    require("polyfill-array-includes");
});



// WEBPACK FOOTER //
// ./src/shared/util/ArrayIncludesPolyfill.js